


import React, { forwardRef, useState } from 'react';
import { prescriptionPrintBottomLineOptions, valuesInPxOptoins } from "Front/variables/Variables.jsx";
import * as PF from "Front/views/Home/PublicFunction.jsx";
import moment from "moment";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";

const Preview = forwardRef(({ patient, services, totalAmount, setShowPreviewModal, totalDiscountAmount, totalPaidAmount, totalRemainingAmount, billNo, refund }, ref) => {
    let userType = localStorage.getItem("userType");
    const [printMarginTop, setPrintMarginTop] = useState("0x");
    const [printMarginBottom, setPrintMarginBottom] = useState("112.2519685px");
    const [printMarginLeft, setPrintMarginLeft] = useState("79.37007874px");
    const [printMarginRight, setPrintMarginRight] = useState("79.37007874px");

    const clinicAddressDetails = JSON.parse(localStorage.getItem("clinicAddressDetails"))
    const clinicName = localStorage.getItem("clinicName")



    const convertPercentageToPx = (dimension, val, paperSize) => {
        let values = valuesInPxOptoins.find((obj) => obj.paperSize === paperSize)
        let widthInPx = values.widthInPx
        let heightInPx = values.heightInPx
        let result = 0
        result = dimension === "width" ? ((widthInPx * val) / 100) : ((heightInPx * val) / 100)
        return result
    }

    const marginTopCss =
        "@media print {.pagebreak-avoid {page-break-inside: avoid !important;page-break-after: avoid !important;page-break-before: avoid !important;break-inside: avoid !important;}.print-table {width: 85%;}.component-to-print-itm{page-break-inside: avoid !important;}@page {  margin-top:" +
        printMarginTop +
        ";margin-bottom:" +
        printMarginBottom +
        ";margin-left:" +
        printMarginLeft +
        ";margin-right:" + printMarginRight + "}}";

    console.log(ref, clinicAddressDetails, "---------ref")

    return (
        <span ref={ref}>
            <style scoped>{marginTopCss}</style>
            <div id="printable" data-template-type="html" className="ui-sortable" style={{ width: '100%' }}>
                <div
                    className={"pad-y print-table marginTop marginBottom"}
                    style={{
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        position: "relative",
                        width: '100%'
                    }}
                >
                    <div className="title_header" id="divPreview">
                        {userType === "doctor" ? (
                            <Button
                                onClick={() => setShowPreviewModal(false)}
                            >
                                <span>Back</span>
                            </Button>
                        ) : userType === "receptionist" &&
                            localStorage.getItem("is_prescription_edit_by_receptionist") ===
                            "yes" ? (
                            <Button
                                onClick={() => setShowPreviewModal(false)}
                            >
                                <span>Back</span>
                            </Button>
                        ) : userType === "educator" &&
                            localStorage.getItem("is_prescription_edit_by_educator") ===
                            "yes" ? (
                            <Button
                                onClick={() => setShowPreviewModal(false)}
                            >
                                <span>Back</span>
                            </Button>
                        ) : (
                            ""
                        )}
                        <h5
                            style={{ fontWeight: "500", fontSize: "14px", marginTop: "0", padding: "10px" }}
                        >
                            Print Preview
                        </h5>
                    </div>
                    <div className='text-center cus-mb-2'>
                        <h2 className='bold cus-pb-5 cus-mb-0 ' style={{ fontWeight: "500" }} >{clinicName}</h2>
                        <p className='cus-mb-0 img-des'>{clinicAddressDetails?.address} - {clinicAddressDetails?.pin_code} ({clinicAddressDetails?.state}) Phone No. {clinicAddressDetails?.phone}</p>

                        <h4 className='cus-mb-0' style={{ fontWeight: "600" }} >CASH RECEIPT</h4>
                    </div>

                    <div className='w-100'>
                        <div className='row  border-top-bash cus-px-5'>
                            <div className='col-sm-12' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className='flex-check-style float-left'>
                                    <label className='bolder cus-mb-0 col-md-auto p-0'> Receipt No.</label>
                                    <p className="txt-black cus-mb-0 col-md-auto">{billNo}</p>
                                </div>

                                <div className='flex-check-style cus-justify-content-end float-right'>
                                    <label className='bolder cus-mb-0 col-md-auto p-0'>Receipt Date.</label>
                                    <p className="txt-black cus-mb-0 col-md-auto">{moment(new Date()).format("DD-MMM-YYYY")}</p>
                                </div>
                            </div>
                        </div>
                        <div className='row border-bm-bash cus-pb-5'>
                            <div className='col-sm-6'>
                                <div className='flex-check-style'>
                                    <label className='bolder cus-mb-0 col-md-auto p-0'> Name.</label>
                                    <p className="txt-black cus-mb-0 col-md-auto">{patient.firstName} {patient.lastName}</p>
                                </div>
                            </div>
                            <div className='col-sm-6'>
                                <div className='text-right'>
                                    <label className='txt-black cus-mb-0'></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* old code */}


                    <div className="table-box">
                        <table className="bill-table print-table-style cus-mb-3">
                            {/* <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Price</th>
                                    <th>Qty</th>
                                    <th>Discount</th> 
                                     <th>Total</th>
                                </tr>
                            </thead> */}
                            <tbody>
                                {services.map(service => (
                                    <tr key={service.id} className='border-bm-bash h-32' style={{ borderBottom: "dashed 1px #000 !important" }}>
                                        <td style={{ widht: "80%" }} >{service.item}</td>
                                        <td className='text-center'></td>
                                        <td className='text-center'>{service.price.toFixed(2)}</td>
                                        {/* <td>{service.quantity}</td>
                                        <td>{service.discount}</td> */}
                                        {/* <td className='text-center'>{(service.price * service.quantity) - service.discount}</td> */}
                                    </tr>
                                ))}
                                <tr className='h-32'>
                                    <td style={{ width: "80%" }}></td>
                                    <td className='text-center border-bm-bash'><span>Payable</span></td>
                                    <td className='text-center border-bm-bash'>{Number(totalAmount).toFixed(2)}</td>
                                </tr>
                                <tr className='h-32'>
                                    <td style={{ width: "80%" }}><span>Received The Sum of Rupees.</span>
                                        <br /><span>{PF.numberToWords(totalPaidAmount)}</span>
                                    </td>
                                    <td className='text-center border-bm-bash'><span>Paid</span></td>
                                    <td className='text-center border-bm-bash'><span>{Number(totalPaidAmount).toFixed(2)}</span></td>
                                </tr>
                                {Number(totalDiscountAmount) > 0 && (
                                    <tr className='h-32'>
                                        <td style={{ width: "80%" }}></td>
                                        <td className='text-center border-bm-bash'><span>Discount</span></td>
                                        <td className='text-center border-bm-bash'><span>{Number(totalDiscountAmount).toFixed(2)}</span></td>
                                    </tr>
                                )}

                                {Number(refund) > 0 && (
                                    <tr className='h-32'>
                                        <td style={{ width: "80%" }}></td>
                                        <td className='text-center border-bm-bash'><span>Refund</span></td>
                                        <td className='text-center border-bm-bash'><span>{Number(refund).toFixed(2)}</span></td>
                                    </tr>
                                )}

                                {Number(totalRemainingAmount) > 0 && (
                                    <tr className='h-32'>
                                        <td style={{ width: "80%" }}></td>
                                        <td className='text-center border-bm-bash'><span>Remaining</span></td>
                                        <td className='text-center border-bm-bash'><span>{Number(totalRemainingAmount).toFixed(2)}</span></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className='cus-px-10'>
                            <p className='cus-mb-0 text-right'>Authorised Signatory.</p>
                        </div>
                    </div>
                </div>
            </div>
        </span>

    );
});

export default Preview;





